module.exports = __webpack_public_path__ + "static/analysis-2fc16cbc81f1ea4bbb788f97428e7d0c.png";